import { Markup } from '@/components/Markup';
import { ProseTheme } from '@/components/Prose/theme';
import { GenericSlot } from 'base/components/GenericSlot';

export const Prose = GenericSlot({ as: Markup, theme: ProseTheme });
